import React from 'react'
import AboutMeContent from '../AboutMeContent'
import './style.css'

function AboutMeContainer() {
    return (
        <div id="about-me-container">
            <AboutMeContent />
        </div>
    )
}

export default AboutMeContainer